import { SearchProps } from '~components/form-fields/search';

const fields: SearchProps = {
  clients_id: {
    defaultShow: true,
    type: 'text-like',
    field: 'full_name',
    caption: 'Client',
    placeholder: 'All',
  },
};

export default fields;
